<template>
  <div class="account-modal">
    <div class="account-modal--scroll">
    <div class="account-modal--box">
      <a @click.prevent="$emit('closeModal')" href="#" class="account-modal--close">
        <svg xmlns="http://www.w3.org/2000/svg" width="26.111" height="26.241" viewBox="0 0 26.111 26.241" xml:space="preserve"><g fill="#7A7A7A"><path d="M3.883 1 25.094 22.21l-2.828 2.829L1.054 3.828z"/><path d="M25.098 3.829 3.885 25.042l-2.83-2.83L22.268 1z"/></g></svg>
      </a>
      <div class="account-complete" v-if="completed">
        <div class="account-modal--title">{{ $store.getters.language.sent_mail_confirm }}</div>
        <hr>
        <div class="account-modal--subtitle">{{ $store.getters.language.check_junk }}</div>
      </div>
      <div class="account-details" v-if="!completed">
      <div class="account-modal--title">{{ $store.getters.language.welcome_to_fillit }}</div>
      <div class="account-modal--subtitle">{{ $store.getters.language.create_account }}</div>
      <div class="account-modal--form">
        <form @submit.prevent="registerUser()">
        <div v-show="page === 1">
          <Input
            v-model="form.email"
            :placeholder="$store.getters.language.email"
            :label="$store.getters.language.email"
            name="email"
            id="email"
            type="email"
            required="required|email"
          />
          <Button
            @click="page = 2"
            :disabled="errors.items.length > 0 || !form.email"
            :prevent="true"
            tag="button"
            :title="$store.getters.language.continue"
          />
          <div class="account-modal--divider">or</div>

          <Button
            :disabled="errors.items.length > 0 || !form.email"
            :prevent="false"
            tag="a"
            href="/users/auth/google"
            data-method="post"
            classes="button--google"
            :title="$store.getters.language.log_in_with_google"
          />
        </div>
        <div v-if="page === 2">
          <Input
            v-model="form.first_name"
            :placeholder="$store.getters.language.first_name"
            :label="$store.getters.language.first_name"
            name="first_name"
            id="first_name"
            type="text"
            required="required"
          />
          <Input
            v-model="form.last_name"
            :placeholder="$store.getters.language.last_name"
            :label="$store.getters.language.last_name"
            id="last_name"
            name="last_name"
            type="text"
            required="required"
          />
          <Input
            v-model="form.email"
            :placeholder="$store.getters.language.email"
            :label="$store.getters.language.email"
            id="email"
            name="email"
            type="email"
            required="required|email"
          />
          <Input
            v-model="form.password"
            :placeholder="$store.getters.language.password"
            :label="$store.getters.language.password"
            id="password"
            name="password"
            type="password"
            required="required"
            />

            <div class="account-modal--smalltext">{{ $store.getters.language.by_signing }}</div>

          <Checkbox
            v-model="form.newsletter"
            :label="$store.getters.language.opt_out"
            name="newsletter"
            id="newsletter"
            :checked="false"
            />

          <Button
            :disabled="errors.items.length > 0 || !form.email || !form.first_name || !form.last_name || !form.password"
            tag="button"
            type="submit"
            title="Agree and continue"
          />
          <!--<div class="account-modal&#45;&#45;divider">or</div>-->

          <!--<Button-->
            <!--:disabled="errors.items.length > 0 || !form.email || !form.first_name || !form.last_name || !form.password"-->
            <!--:prevent="false"-->
            <!--tag="a"-->
            <!--href="users/auth/google"-->
            <!--data-method="post"-->
            <!--classes="button&#45;&#45;google"-->
            <!--:title="$store.getters.language.log_in_with_google"-->
          <!--/>-->
        </div>

        </form>
      </div>
      </div>
      </div>
    </div>
    <div @click.prevent="$emit('closeModal')" class="account-modal--backdrop"></div>
  </div>
</template>

<script>
import axios from 'axios'
import Input from "../forms/Input"
import Checkbox from "../forms/Checkbox"
import Button from "../forms/Button"

export default {
  name: 'AccountModal',
  data: () => ({
    completed: false,
    form: {
      email: null,
      first_name: null,
      last_name: null,
      password: null,
      newsletter: null,
      team_id: null
    },
    page: 1
  }),
  components: {
    Input,
    Checkbox,
    Button
  },
  computed: {
  },
  created () {
  },
  methods: {
    registerUser () {
      var user = { user: this.form }
      console.log(user)
      var token = document.head.querySelector("[name=csrf-token]").content
      axios.post('/users', user,
      {
        headers: {
            'Content-type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': token
        }
      }).catch(function (error) {
          console.log(error)
      }).then(response => {
          console.log(response)
          this.completed = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../scss/global/includes";

.account-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1009;
  overflow-y: scroll;
}

.account-modal--close {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 20px;

  svg {
    width: 100%;
  }
}

.account-modal--scroll {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 0 15px;
}

.account-modal--backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.account-modal--box {
  margin: 20px 0;
  z-index: 1001;
  position: relative;
  width: 560px;
  background: #FFFFFF;
  border-radius: 6px;
  padding: 5vw;
  border: 1px solid #9B9B9B;
}

.account-modal--title {
  text-align: center;
  width: 100%;
  font-size: 32px;
  color: $primary;
  font-family: $font-bold;
}

.account-modal--subtitle {
  text-align: center;
  width: 100%;
  font-size: 18px;
  margin-bottom: 20px;
  display: block;
}

.account-modal--divider {
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  margin: 30px 0;
  gap: 30px;
  &:before {
    content: "";
    height: 1px;
    background: #9B9B9B;
    width: 100px;
  }
  &:after {
    content: "";
    height: 1px;
    background: #9B9B9B;
    width: 100px;
  }
}

.account-modal--smalltext {
  font-size: 12px;
  margin-bottom: 10px;
  display: block;
}


</style>
